import { render, staticRenderFns } from "./ParticipantGroupField.vue?vue&type=template&id=224fd900"
import script from "./ParticipantGroupField.vue?vue&type=script&lang=js"
export * from "./ParticipantGroupField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports